export default __webpack_public_path__ + "static/media/G0004.fa139231.png";